<template>
  <v-container style="max-width: 1000px;">
    <v-row>
      <v-col align="center">
        <v-img
          width="150px"
          src="@/assets/logo.png"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" align="center">
        <h2 class="text-h5 font-weight-bold text-center mb-3">
          Informe o CSRT para criptografar
        </h2>
        <v-text-field 
          v-model="csrt_original"
          background-color="black"
          dark
          outlined
        ></v-text-field>
        <div>
          <v-btn 
            dark
            rounded="lg" 
            size="lg"
            @click="cripto()"
          >
            Criptografar
          </v-btn>
        </div>
        <h2 
          class="mt-5 text-h5 font-weight-bold text-center mt-8 mb-3"
        >
          CSRT Criptografado
        </h2>
        <v-text-field 
          v-model="csrt_criptografado"
          background-color="black"
          dark
          readonly 
          outlined
        ></v-text-field>
        <div>
          <v-btn
            :disabled="csrt_criptografado == ''"
            dark
            rounded="lg" 
            size="lg"
            v-clipboard="() => this.csrt_criptografado"
            v-clipboard:success="clipboardSuccess"
            v-clipboard:error="clipboardError"
          >
            Copiar
          </v-btn>
          <v-btn 
            dark
            rounded="lg" 
            size="lg"
            @click="limpar()"
          >
            Limpar
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      color="red"
      shaped
      elevation="24"
      centered
      h2--text
    >
      <h1>{{ text }}</h1>
    </v-snackbar>
  </v-container>
</template>

<script>
import { encriptar } from "../cripto";

export default {  
  data() {
    return {
      csrt_original: "",
      csrt_criptografado: "",
      snackbar: false,
      text: "",
      timeout: 2000,
    }
  },

  methods: {
    clipboardSuccess() {
      this.text = "CSRT copiado com sucesso"
      this.snackbar = true
    },

    clipboardError() {
      this.text = "Erro ao copiar o CSRT,"
      this.snackbar = true
    },

    cripto() {
      this.csrt_criptografado = encriptar(this.csrt_original);
    },

    limpar() {
      this.csrt_original = "";
      this.csrt_criptografado = "";
    }
  },
  
  mounted() {
    this.limpar();
  }
}

</script>
